import { Component, computed, input } from '@angular/core';

import {
  formatCellValue,
  processStringValue
} from '@shared/components/table/table-cell/utils';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '../../table-cell.component';

@Component({
  selector: 'app-id-cell',
  standalone: true,
  templateUrl: './id-cell.component.html'
})
export class IdCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'string');

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<string>(() => processStringValue(this.value()));
}
